import { render, staticRenderFns } from "./YesNo.vue?vue&type=template&id=6961bc38"
import script from "./YesNo.vue?vue&type=script&lang=js"
export * from "./YesNo.vue?vue&type=script&lang=js"
import style0 from "./YesNo.vue?vue&type=style&index=0&id=6961bc38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports